import { AnimatePresence } from 'framer-motion'

import { useManagementGetNonAllocatedSims } from '@apps-common/apis/management/non-allocated-sim'
import { useManagementSearchSimApns } from '@apps-common/apis/management/sim-apn'
import {
  NonAllocatedSimCardSkeleton,
  NonAllocatedSimListCard
} from '@apps-common/apps/portal/pages/management/components/non-allocated-sim'
import { NoResultsCard, PullRefresh } from '@apps-common/components/common'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'

interface IProps {
  searchVal: string
}

export const NonAllocatedSimInfiniteView: React.FC<IProps> = ({ searchVal }) => {
  const { isLoading: saIsLoading, isError: saIsError, data: simApns } = useManagementSearchSimApns({})
  const { isLoading, isError, data, refetch, isRefetching } = useManagementGetNonAllocatedSims({
    search: searchVal
  })

  const loading = saIsLoading || saIsError || !simApns || isLoading || isError || !data || isRefetching

  return (
    <LayoutContainer>
      <LayoutPadding topPadding='pt-[60px]'>
        <PullRefresh loading={isRefetching} callback={() => refetch()} />{' '}
        <AnimatePresence>
          <div className='flex flex-col gap-4'>
            {loading &&
              Array.from(Array(20).keys()).map((i) => <NonAllocatedSimCardSkeleton key={`non-allocated-sim-card-skeleton-${i}`} />)}
            {!loading &&
              data?.map((s) => <NonAllocatedSimListCard key={`non-allocated-sim-list-${s.id}`} simApns={simApns || []} sim={s} />)}
            {!loading && data && data.length === 0 && <NoResultsCard>No sim results.</NoResultsCard>}
          </div>
        </AnimatePresence>
      </LayoutPadding>
    </LayoutContainer>
  )
}
